import { District, Nullish, Sport, State } from 'types'

export const FEATURE_NAME = 'filters'

export interface IState {
  state: Nullish<State>
  district: Nullish<District>
  sport: Nullish<Sport>
  isOverall: boolean
}

export enum LeagueSwitch {
  OVERALL = 'Overall',
  LEAGUE = 'League',
}
